import React from "react";
import {Spinner} from "@seismic/mantle";

export const CenteredSpinner = (props) => {

    return <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: props.height ?? "100vh"}}>
        <div style={{backgroundColor: "white", border: "1px solid #CFD4DA", borderRadius: "8px", padding: "24px", textAlign: "center"}}>
            <Spinner />
            {props?.message ? <div style={{padding: "4px"}}>{props.message}</div> : null}
        </div>
    </div>

}

export const CenteredSpinner2 = (props) => {

    return <div style={{display: "grid"}}>
        <div style={{padding: "16px", textAlign: "center"}}>
            <Spinner />
            {props?.message ? <div style={{padding: "16px"}}>{props.message}</div> : null}
        </div>
    </div>

}

export const ApiResult = (props) => {

    if(props.status === "idle" || props.status === "loading")
        return <CenteredSpinner2 message={props.message} />

    if(props.status === "failed" && props.error.indexOf("401 (Unauthorized)") >= 0)
        return <div>
            Token Expired - please sign in again.
        </div>

    if(props.status === "error" || props.status === "failed")
        return <div className="text-danger">
            <h5>{props.message} Failed</h5>
            <p>
                {props.error}
            </p>
        </div>

    return props.children
}
